import React from 'react'
import { useContext } from 'react'
import NoteContext from '../context/notes/noteContext'
import { useState} from 'react'

export default function AddNote() {
    const context = useContext(NoteContext)
    const { addNote } = context
    const [noteInput, setNoteInput] = useState({ title: "", description: "" ,tag:""})



    return (
        <div>
            

            <p className="h1 ">Add  a Note</p>
            <form onSubmit={(e) => { addNote(e, noteInput.title, noteInput.description,noteInput.tag);setNoteInput({title:"",description:"",tag:""}) }}>
                <div className="mb-3"> 
                    <label for="exampleInputEmail1" className="form-label">Title</label>
                    <input onChange={(e) => setNoteInput({ ...noteInput, title: e.target.value })} value={noteInput.title} type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" required={true} />
                    {/* <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div> */}
                </div>
                <div className="mb-3">
                    <label for="exampleInputPassword1" className="form-label">Description</label>
                    <input value={noteInput.description} onChange={(e) => setNoteInput({ ...noteInput, description: e.target.value })} type="text" className="form-control" id="exampleInputPassword1" required={true} />
                </div>
                <div className="mb-3">
                    <label for="exampleInputPassword1" className="form-label">Tag</label>
                    <input value={noteInput.tag} onChange={(e) => setNoteInput({ ...noteInput, tag: e.target.value })} type="text" className="form-control" id="exampleInputPassword1" required={true} />
                </div>

                <button type='submit' className="btn btn-primary">Add</button>
        
            </form>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/addnote.jsx